import React, { useState } from "react";
import { FaFileAlt, FaToggleOn, FaToggleOff, FaTrash, FaExclamationTriangle, FaTimes } from "react-icons/fa";
import { ReportModel } from "./_core/_model";
import { getMyLocalTime } from "../../Utilities/Utilities.ts";
import TooltipButton from "../Tools/TooltipButton.tsx";
import { HiUserRemove } from "react-icons/hi";


interface ReportCardProps {
  report: ReportModel;
  userName: string;
  onToggle: (id: number) => void;
}

export const ReportCard: React.FC<ReportCardProps> = ({ report, userName, onToggle }) => {
  const [toggleClicked, setToggleClicked] = useState<any | null>(null);
  return (
    <div className="card shadow-sm mb-3">
      <div className="card-body d-flex justify-content-between align-items-center j_u_r_card">
        <div className="d-flex align-items-center gap-3">
          <FaFileAlt className="text-primary fs-3" />
          <div>
            <h5 className="mb-1">{report.workspaceName}: {report.reportName}</h5>
            <div className="text-muted-theme small">
              <div>Created On: {getMyLocalTime(report.createdAt)}</div>
            </div>
          </div>
        </div>
        <TooltipButton title={<span>Click to remove <b>{userName}</b> from the distribution list for this report.</span>}>
          <div role="button" onClick={() => {
            setToggleClicked(<span>Are you sure you want to remove <b>{userName}</b> from the {report.reportName} distribution list?<br/>This will stop all future deliveries of this report to the user.</span>)
          }}>
            <HiUserRemove size={20} className="text-success fs-4 j_u_r_rem" />
          </div>
        </TooltipButton>
      </div>
      {toggleClicked != null && (
        <div
          className="modal fade show"
          style={{
            display: 'block',
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            transition: 'opacity 0.3s ease-in-out'
          }}
          tabIndex={-1}
          role="dialog"
        >
          <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content animate__animated animate__fadeInDown">
              <div className="modal-header fw-bold">
                <h5 className="modal-title d-flex align-items-center gap-2">
                  <HiUserRemove size={24} />
                  Confirm remove from distribution
                </h5>
                <button type="button" className="btn-close btn-close" onClick={(e) => {
                  e.stopPropagation();
                  setToggleClicked(null);
                }}></button>
              </div>
              <div className="modal-body text-center">
                <FaExclamationTriangle size={40} color="#dc3545" className="mb-3" />
                <p className="fs-6 text-secondary text-break">{toggleClicked}</p>
              </div>
              <div className="modal-footer">
                <button className="btn btn-outline-secondary d-flex align-items-center gap-1" onClick={(e) => {
                  e.stopPropagation();
                  setToggleClicked(null);
                }}>
                  <FaTimes />
                  No
                </button>
                <button className="btn btn-danger text-white d-flex align-items-center gap-1" onClick={(e) => {
                  e.stopPropagation();
                  onToggle(report.reportAutoID);
                  setToggleClicked(null);
                }}>
                  <FaTrash />
                  Yes
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
